var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 243.85 338.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2b8ead;}.cls-2{fill:#4fc0eb;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ping") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_5",
    "data-name": "Capa 5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126.68,12.5A117.18,117.18,0,0,0,9.5,129.68c0,64.71,117.18,208.59,117.18,208.59S243.85,194.39,243.85,129.68A117.17,117.17,0,0,0,126.68,12.5Zm0,170.76a54.77,54.77,0,1,1,54.77-54.77A54.77,54.77,0,0,1,126.68,183.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M117.18,0A117.18,117.18,0,0,0,0,117.18c0,64.71,117.18,208.59,117.18,208.59S234.35,181.89,234.35,117.18A117.17,117.17,0,0,0,117.18,0Zm0,170.76A54.77,54.77,0,1,1,172,116,54.77,54.77,0,0,1,117.18,170.76Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPing);
export default __webpack_public_path__ + "static/media/ping.7ededc12737010a26a41a133521b1146.svg";
export { ForwardRef as ReactComponent };